import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
 
  filtersWrapperStyle: {
    marginLeft: '20px !important',
  },

}));
